import { createFileRoute } from '@tanstack/react-router'

import { ExcludedSubscriptionsDataGridPage } from '../../../components/pages/backoffice/excluded-subscriptions/excluded-subscriptions-data-grid-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/excluded-subscriptions/')({
  component: () => (
    <PermissionChecker requiredPermissions={['excludedSubscription.manage']}>
      <ExcludedSubscriptionsDataGridPage />
    </PermissionChecker>
  ),
})
